import { ComponentType } from 'react';
import { V2ProductPageProps } from '../types';
import { ApvSelectPage } from './apv-select-insurance';
import { ApvSelectOnePage } from './apv-select-one-insurance';
import { FamilySavingsV2Page } from './family-savings-insurance';
import { LifeMaxV2Page } from './life-max-insurance';
import { UniversitySavingsV2Page } from './university-savings-insurance';

export const V2_PRODUCT_REGISTRY: Record<string, ComponentType<V2ProductPageProps>> = {
  'apv-select-insurance': ApvSelectPage,
  'apv-select-one-insurance': ApvSelectOnePage,
  'family-savings-insurance': FamilySavingsV2Page,
  'university-savings-insurance': UniversitySavingsV2Page,
  'life-max-insurance': LifeMaxV2Page,
};
